import { useEffect } from 'react';

function usePasswordMatch(watch, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
trigger, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
control) {
    const password = watch({
        control,
        name: 'password',
    });
    const confirmPassword = watch({
        control,
        name: 'confirmPassword',
    });
    useEffect(() => {
        if (password && confirmPassword) {
            trigger('confirmPassword');
        }
    }, [password, trigger]);
}

export { usePasswordMatch as default };
//# sourceMappingURL=usePasswordMatch.js.map
